<app-page-loader [active]="pageLoading"></app-page-loader>
<app-header
    *ngIf="showMainHeader()"></app-header>
<main class="forlab-app-main">
  <router-outlet></router-outlet>
</main>
<ng-container *ngIf="chatAvailable$ | async">
  <app-chat-shell></app-chat-shell>
  <app-chat-launcher></app-chat-launcher>
</ng-container>
